import { SET_ENVIRONMENT_HISTORY_OPENED } from "./environment-history-types";

export const setEnvironmentHistoryOpened = (isOpened: boolean) => ({
    type: SET_ENVIRONMENT_HISTORY_OPENED,
    isOpened,
});
